import React from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { getTranslatedRegionsArray } from "bundles/common/utils/utils.js";
import { useSelector } from "react-redux";

const PreferencesView = (props) => {
  const intl = useIntl();
  const candidate =
    useSelector((state) => state.current_candidate) || props?.candidate || {};

  const desiredList = Array.isArray(candidate?.desired_locations)
    ? candidate.desired_locations.map((l) => (typeof l === "string" ? l : l?.label)).filter(Boolean)
    : [];
  const regions = candidate?.region
    ? [...new Set(desiredList.concat(candidate.region).filter(Boolean))]
    : desiredList;

  return (
    <Grid container spacing={1} align="left">
      {candidate?.desired_job_title && (
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            <FormattedMessage id="candidate.desired_job_title" />
          </Typography>
          <Typography
            variant="body2"
            style={{ fontFamily: "Segoe UI Regular, sans-serif", wordBreak: "normal" }}
          >
            <b>
              {candidate?.desired_job_title || (
                <FormattedMessage id="undefined" />
              )}
            </b>
          </Typography>
        </Grid>
      )}
      {regions.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            <FormattedMessage id="candidate.desired_locations" />
          </Typography>
          <Typography
            variant="body2"
            style={{ fontFamily: "Segoe UI Regular, sans-serif", wordBreak: "normal" }}
          >
            <b>{getTranslatedRegionsArray(intl, regions)}</b>
          </Typography>
        </Grid>
      )}
      {candidate?.desired_job_type && (
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            <FormattedMessage id="candidate.desired_job_type" />
          </Typography>
          <Typography
            variant="body2"
            style={{ fontFamily: "Segoe UI Regular, sans-serif", wordBreak: "normal" }}
          >
            <b>
              {candidate?.desired_job_type || (
                <FormattedMessage id="undefined" />
              )}
            </b>
          </Typography>
        </Grid>
      )}
      {candidate?.desired_sector?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            <FormattedMessage id="company.company_industry.company_industry" />
          </Typography>
          <Typography
            variant="body2"
            style={{ fontFamily: "Segoe UI Regular, sans-serif", wordBreak: "normal" }}
          >
            <b>
              {candidate?.desired_sector?.length > 0 ? (
                candidate.desired_sector.map((sector, index) => (
                  <React.Fragment key={sector}>
                    {index > 0 && ", "}
                    <FormattedMessage id={"company.company_industry." + sector} />
                  </React.Fragment>
                ))
              ) : (
                <FormattedMessage id="undefined" />
              )}
            </b>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
export default PreferencesView;
